import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  theme: localStorage.getItem('THEME'),
  openedProjects: [],
  isContactModalOpen: false,

  loadingActions: {},
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    changeTheme: (state, action) => {
      state.theme = action.payload;
    },

    openProject: (state, action) => {
      state.openedProjects = [...state.openedProjects, action.payload];
    },
    removeOpenedProject: (state, action) => {
      state.openedProjects = state.openedProjects.filter((id) => id !== action.payload);
    },
    openContactModal: (state) => {
      state.isContactModalOpen = true;
    },
    closeContactModal: (state) => {
      state.isContactModalOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => action.type.endsWith('/pending'),
        (state, action) => {
          const actionType = action.type.replace('/pending', '');
          state.loadingActions[actionType] = true;
        },
      )
      .addMatcher(
        (action) => action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected'),
        (state, action) => {
          const actionType = action.type.replace(/\/(fulfilled|rejected)$/, '');
          state.loadingActions[actionType] = false;
        },
      );
  },
});

export const { changeTheme, openProject, removeOpenedProject, openContactModal, closeContactModal } =
  globalSlice.actions;

export default globalSlice.reducer;
